import React, { FC, useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { useRouter } from 'next/router';
import useTranslation from '@hooks/useTranslation';
import ContentTemplate from '@ui/Content/Content';
import Title, { TitleTagTypes } from '@ui/SectionTitle/Title';
import { publicAssets } from '@utils/url.utils';
import { ROUTES } from '../../constants';
import { PicSource, PicWrapper, Wrapper } from './Gallery.elements';

const GalleryTemplate: FC = () => {
    const { t } = useTranslation();

    const router = useRouter();

    const CompanyCoursesImage = [
        publicAssets('/events1.webp'),
        publicAssets('/events6.webp'),
        publicAssets('/events2.webp'),
        publicAssets('/events3.webp'),
        publicAssets('/events5.webp'),
        publicAssets('/events4.webp'),
    ];

    const AboutUsImage = [
        publicAssets('/about6.webp'),
        publicAssets('/about1.webp'),
        publicAssets('/about3.webp'),
        publicAssets('/about4.webp'),
        publicAssets('/about2.webp'),
        publicAssets('/about5.webp'),
    ];

    const [showAll, setShowAll] = useState(false);
    const [imgFocus, setImgFocus] = useState(false);
    const [imgIndex, setImgIndex] = useState(0);
    const [images, setImages] = useState(
        router.pathname.includes(ROUTES.ABOUT_US) ? AboutUsImage : CompanyCoursesImage
    );

    const minImgShowCount = 6;

    return (
        <ContentTemplate withPadding mobileSidePadding={20}>
            <Title tagType={TitleTagTypes.H3} isBlack>
                {t('about.gallery.title')}
            </Title>
            <Wrapper>
                {images.map((img, index) => {
                    return showAll || index < minImgShowCount ? (
                        <PicWrapper key={index}>
                            <PicSource
                                src={img}
                                onClick={() => {
                                    setImgIndex(index);
                                    setImgFocus(true);
                                }}
                            />
                        </PicWrapper>
                    ) : null;
                })}
            </Wrapper>
            {imgFocus && (
                <Lightbox
                    mainSrc={images[imgIndex]}
                    nextSrc={images[(imgIndex + 1) % images.length]}
                    prevSrc={images[(imgIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setImgFocus(false)}
                    onMovePrevRequest={() => setImgIndex((imgIndex + images.length - 1) % images.length)}
                    onMoveNextRequest={() => setImgIndex((imgIndex + 1) % images.length)}
                />
            )}
        </ContentTemplate>
    );
};

export default GalleryTemplate;
